import script from "./ShopForVisitor.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopForVisitor.vue?vue&type=script&setup=true&lang=js"

import "./ShopForVisitor.vue?vue&type=style&index=0&id=68be5bb3&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68be5bb3"]])

export default __exports__